import useArticleSection from "@FillInTableContainer/hooks/useArticleSection";

import { ArticleMainLabelListFactory } from "../libs/articleMainLabelList/articleMainLabelListFactory";

export const useHandleMainLabelList = () => {
  const articleSection = useArticleSection();

  return ArticleMainLabelListFactory.createArticleMainLabelList(articleSection);
};
